import { CiLinkedin } from "react-icons/ci";
import { CiInstagram } from "react-icons/ci";
import { Link } from "react-router-dom";
import wave1 from '../assets/img/wave1.svg';
import wave2 from '../assets/img/wave2.svg';
import logo from '../assets/img/logo.png';
import FooterMenu from "components/Menus/FooterMenu";

export default function Footer() {

    return(

        <footer>
            <div className='footer_content'>
                <div className="footer_columns">
                    <div className="footer_column">
                        <img
                            src={logo}
                            alt="logo"
                            style={{ width: '180px', height: 'auto' }} />
                    </div>
                    <div className="footer_column">
                        <h3 className="footer_menu_title">Menu</h3>
                        <FooterMenu />
                    </div>

                    <div className="footer_column">
                        <h3>NOSOTROS</h3>

                        <Link to={"/preguntas-frecuentes"} className="footer_link">
                            Preguntas frecuentes
                        </Link>
                        <Link to={"/terminos"} className="footer_link">
                            Términos y condiciones
                        </Link>
                        <p>Fontanarosa Spa</p>
                        <p>Rut: 77896452-K</p> 
                        <p>Representante Legal: Gabriel Toledo Birke</p>
                       
                        <div className="footer_social">
                            <Link
                                style={{color: 'white'}}
                                target="_blank"
                                to={"https://www.linkedin.com/company/especialistaenheridas-cl/"}>
                                <CiLinkedin size={45} />
                            </Link>
                            <Link
                                style={{color: 'white'}} 
                                target="_blank"
                                to={"https://www.instagram.com/especialistaenheridas.cl/profilecard/?igsh=bXhqcDNqZDNzdDBj "}>
                                <CiInstagram size={45} />
                            </Link>
                        </div>
                    </div>
                </div>

                <p className="disclaimer">Todo contacto oficial de Especialistaenheridas.cl será llevado a cabo a través de
                su correo oficial ( contacto@especialistaenheridas.cl) o su cuenta de Instagram ( @especialistaenheridas.cl)</p>

                <div className="footer_credit">
                    <span>© {new Date().getFullYear()} Especialista en Heridas · Desarrollado por Sergio Mancilla Escobar</span>
                </div>
            </div>
            <div className='footer_box'>
                <img src={wave2} alt="" className='waves wave2' />
                <img src={wave1} alt="" className='waves wave1' />
            </div>
            
        </footer>

    )
}